import {Instagram, Mail, Youtube} from 'lucide-react';
import { useState, useEffect } from 'react';
import { lumi } from '../lib/lumi';

const Footer = () => {
  const [instagramUrl, setInstagramUrl] = useState('https://www.instagram.com/studiorochecolombe/');
  const [emailUrl, setEmailUrl] = useState('studiorochecolombe@gmail.com');
  const youtubeUrl = 'https://www.youtube.com/@rochecolombe';

  useEffect(() => {
    const fetchContent = async (attempt = 0) => {
      try {
        const result = await lumi.entities.site_content.list({ filter: { page: 'footer' } });
        result?.list?.forEach((item: any) => {
          if (item.section === 'info') {
            if (item.content?.instagramUrl) setInstagramUrl(item.content.instagramUrl);
            if (item.content?.email) setEmailUrl(item.content.email);
          }
        });
      } catch (error) {
        if (attempt < 1) {
          setTimeout(() => fetchContent(attempt + 1), 1500);
        } else {
          console.error('Error loading footer content, using default Studio RocheColombe contact details:', error);
        }
      }
    };
    fetchContent();
  }, []);

  return (
    <footer className="bg-[#FAF9F6] text-[#2C2C2C] pt-14">
      <div className="max-w-7xl mx-auto px-6">

        {/* Logo */}
        <div className="flex justify-center mb-6">
          <a href="/" aria-label="Studio RocheColombe — Home">
            <img
              src="https://static.lumi.new/44/4495c6feb2104e9b3b6d9f89ff4c7729.webp"
              alt="Studio RocheColombe"
              className="h-16 w-auto object-contain opacity-90 hover:opacity-100 transition-opacity" />

          </a>
        </div>

        {/* Tagline */}
        <p
          className="text-center mb-12 text-lg"
          style={{ fontFamily: "'Roboto', Helvetica, Arial, sans-serif", fontStyle: 'italic', fontWeight: 300, color: '#6B4534' }}>

          An undulatory art experience
        </p>

        {/* Three columns */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-10 mb-12 pb-12">

          {/* Navigation */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-[#6B4534] mb-4">Navigation</h4>
            <ul className="space-y-2.5 text-sm">
              {[
              { label: 'Gallery', href: '/gallery' },
              { label: 'About', href: '/about' },
              { label: 'Contact', href: '/contact' },
              { label: 'News & Events', href: '/actualites' }].
              map(({ label, href }) =>
              <li key={href}>
                  <a href={href} className="text-[#2C2C2C]/65 hover:text-[#6B4534] transition-colors">
                    {label}
                  </a>
                </li>
              )}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-[#6B4534] mb-4">Legal</h4>
            <ul className="space-y-2.5 text-sm">
              {[
              { label: 'Legal Notice', href: '/legal-notice' },
              { label: 'Terms & Conditions', href: '/terms' },
              { label: 'Shipping Policy', href: '/shipping' },
              { label: 'Privacy Policy', href: '/privacy-policy' },
              { label: 'Terms of Use', href: '/terms-of-use' }].
              map(({ label, href }) =>
              <li key={href}>
                  <a href={href} className="text-[#2C2C2C]/65 hover:text-[#6B4534] transition-colors">
                    {label}
                  </a>
                </li>
              )}
            </ul>
          </div>

          {/* Follow me */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-[#6B4534] mb-4">Follow</h4>
            <div className="flex gap-3">
              <a
                href={instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#6B4534]/10 text-[#6B4534] rounded-full flex items-center justify-center hover:bg-[#6B4534] hover:text-[#FAF9F6] transition-colors"
                aria-label="Instagram">

                <Instagram size={18} />
              </a>
              <a
                href={youtubeUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#6B4534]/10 text-[#6B4534] rounded-full flex items-center justify-center hover:bg-[#6B4534] hover:text-[#FAF9F6] transition-colors"
                aria-label="YouTube">
                <Youtube size={18} />
              </a>
              <a
                href={`mailto:${emailUrl}`}
                className="w-10 h-10 bg-[#6B4534]/10 text-[#6B4534] rounded-full flex items-center justify-center hover:bg-[#6B4534] hover:text-[#FAF9F6] transition-colors"
                aria-label="Email">

                <Mail size={18} />
              </a>
            </div>
          </div>
        </div>

      </div>

      {/* Final band: solid graphite background */}
      <div className="bg-[#3A2F28] text-[#FAF9F6] py-8">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center text-sm text-[#FAF9F6]/80">
            &copy; 2026 Studio RocheColombe. All rights reserved.
          </div>

          {/* Cortex Digital credit */}
          <div className="cortex-credit">
            <span>Site créé par</span>
            <a href="https://cortexdigital.ch" target="_blank" rel="noopener">
              <img src="https://static.lumi.new/material/2d/2d7e87bf6733fa45e1f47a6b3f26cfce.png" alt="Cortex Digital" loading="lazy" decoding="async" className="object-contain brightness-0 invert"></img>
            </a>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;